<router-outlet></router-outlet>

<app-loading [global]="true"></app-loading>
